import React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ActivityIndicator, Image, ScrollView, StyleSheet, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import * as authActions from '../../store/actions/auth';
import { i18nNS, useComponentTKey } from '../../i18n';
import { Color, CommonProperties, CommonStyles } from '../../styles';
import BaseText from '../BaseText';
import Button from '../Button';
import InputForm from '../InputForm';
import AsyncStoreService from '../../services/async-store.service';

const AALoginScreenModal = ({ navigation }) => {
  const user = useSelector((state) => state && state.auth && state.auth.user);
  const { t } = useTranslation(i18nNS.login);
  const { tKey } = useComponentTKey('LoginScreen');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessages, setErrorMessages] = useState({});
  const [bioData, setBioData] = useState({ user: null, password: null, available: null });
  const isLoading = useSelector((state) => state.auth.loginLoading);
  const dispatch = useDispatch();

  const isValid = () => {
    const _errorMessages = {};
    if (!email) {
      _errorMessages.email = t('common:Error.requiredEmail');
    }
    if (!password) {
      _errorMessages.password = t('common:Error.requiredPassword');
    }
    setErrorMessages(_errorMessages);
    return Object.keys(_errorMessages).length === 0;
  };

  const onPressLogin = async () => {
    if (!isValid()) {
      return;
    }
    await dispatch(
      authActions.userAuthenticate({
        userName: email,
        password,
        storeEmail: bioData.user,
        storePassword: bioData.password,
        bioAvailability: bioData.available,
      })
    );

    const userData = await AsyncStoreService.getUserData();
    if (userData) {
      navigation.goBack();
    }
  };

  return (
    <ScrollView>
      <View style={styles.body}>
        <Image style={styles.logo} source={require('../../assets/img/login-logo.png')} />
        <BaseText style={styles.loginText}>{t(tKey('LoginHeader'))}</BaseText>
        <View style={styles.form}>
          <InputForm
            placeholder={t(tKey('EnterEmail'))}
            errorMessage={errorMessages.email}
            value={email}
            onChangeText={(e) => setEmail(e.trim())}
          />

          <InputForm
            placeholder={t(tKey('EnterPassword'))}
            value={password}
            errorMessage={errorMessages.password}
            secure={true}
            onChangeText={setPassword}
          />
          <Button
            label={t('common:Login')}
            style={styles.submitButton}
            labelStyle={CommonStyles.h2}
            onPress={onPressLogin}
          />
        </View>
      </View>
      {isLoading && <ActivityIndicator color={Color.primary} />}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  logo: {
    resizeMode: 'contain',
    width: '90%',
    height: 60,
    maxWidth: 300,
    ...CommonProperties.mb5,
  },
  body: {
    marginBottom: 60,
    alignContent: 'stretch',
    alignItems: 'center',
    ...CommonProperties.p5,
  },
  loginText: {
    textAlign: 'center',
    ...CommonProperties.h2,
    ...CommonProperties.py5,
  },
  form: {
    width: '100%',
    maxWidth: 420,
  },
  submitButton: {
    ...CommonProperties.borderRadius4,
    ...CommonProperties.py3,
    ...CommonProperties.boxShadow,
  },
});

export default AALoginScreenModal;
